import Supercluster from 'supercluster';
import type { PointRecord } from '../types';
import { toUVTL, uvToLngLat, lngLatToUv, fromUVTL } from '../viewer/coords';

export type ClusterIndex = Supercluster<{ id: string; faction: string; name: string; xTL: number; yTL: number; }>;

export function buildClusterIndex(points: PointRecord[]): ClusterIndex {
  const features = points.map((p) => {
    const { uTL, vTL } = toUVTL(p.xTL, p.yTL);
    const { lng, lat } = uvToLngLat(uTL, vTL);
    return {
      type: 'Feature' as const,
      geometry: { type: 'Point' as const, coordinates: [lng, lat] as [number, number] },
      properties: { id: p.id, faction: p.faction, name: p.name, xTL: p.xTL, yTL: p.yTL },
    };
  });
  const index = new Supercluster<{ id: string; faction: string; name: string; xTL: number; yTL: number }>({
    radius: 60,
    maxZoom: 16,
    minPoints: 2,
  });
  index.load(features as any);
  return index as ClusterIndex;
}

export function featureToImageXY(f: any) {
  if (f.properties?.cluster) {
    const [lng, lat] = f.geometry.coordinates as [number, number];
    const { uTL, vTL } = lngLatToUv(lng, lat);
    const { xTL, yTL } = fromUVTL(uTL, vTL);
    return { xTL, yTL };
  } else {
    return { xTL: f.properties.xTL as number, yTL: f.properties.yTL as number };
  }
}

